import axios from 'axios'

/**
 * Shared API client. Global response error handling (retries, popups, logging)
 * is registered by ErrorHandlerPlugin in main.ts.
 */
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_ENDPOINT_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default apiClient
